import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  CloseButton,
} from '@chakra-ui/react';
import { VoxGuruLogo } from 'voxguru-v1/assets';
import AppBox from 'voxguru-v1/components/chakraLayoutOverrides/AppBox';
import AppText from 'voxguru-v1/components/Typography/AppText';
import { APP_STUDENT_LOGIN_SCREEN } from 'voxguru-v1/navigation//routes';
import AppFlex from 'voxguru-v1/components/chakraLayoutOverrides/AppFlex';
import { ChevronDownIcon } from '@chakra-ui/icons';
import appColors from 'voxguru-v1/theme/appColors';
import useAppStore from 'voxguru-v1/store';
import { useMutation } from 'react-query';
import makePostRequest from 'voxguru-v1/api/utils/makePostRequest';
import { APP_TEACHER_LOGOUT } from 'voxguru-v1/api/urls/teacher';
import removeUserToken from 'voxguru-v1/api/utils/removeUserToken';
import { useNavigate } from 'react-router-dom';
import getIsWebView from 'voxguru-v1/utils/getIsWebView';
import { useMemo } from 'react';
import { REACT_NATIVE_MESSAGES } from '../../utils/constants';

function AppStudentNavbar() {
  const isAuthenticated = useAppStore.getState().is_authenticated;
  const username = useAppStore.getState().user_name;
  const navigate = useNavigate();
  const { mutate: teacherLogoutMutation } = useMutation(() =>
    makePostRequest(APP_TEACHER_LOGOUT),
  );

  const handleStudentLogout = () => {
    teacherLogoutMutation();
    removeUserToken();
    navigate(APP_STUDENT_LOGIN_SCREEN);
  };

  const handleWebViewNavbarClose = () => {
    window.ReactNativeWebView.postMessage(REACT_NATIVE_MESSAGES.GO_BACK);
  };

  const isResponsive = useMemo(() => getIsWebView(), []);
  // eslint-disable-next-line no-nested-ternary
  return isAuthenticated ? (
    isResponsive ? (
      <AppBox variant="mobileNavbar">
        <CloseButton
          size="lg"
          onClick={handleWebViewNavbarClose}
          color={appColors.brandGrey[700]}
        />
        <AppText title="Live Class" variant="mobileNavbarText" />
      </AppBox>
    ) : (
      <Flex
        height="80px"
        px={10}
        mb={5}
        justifyContent="space-between"
        alignItems="center"
      >
        <AppBox>
          <img src={VoxGuruLogo} alt="" />
        </AppBox>
        {/* <AppBox> */}
        {/*  <AppNavLink title="Programs" to={TEACHER_DASHBOARD} /> */}
        {/* </AppBox> */}
        <AppFlex
          customStyles={{
            alignItems: 'center',
          }}
        >
          <AppText
            title="Hello"
            size="xs"
            customStyles={{
              color: appColors.brandGrey['900'],
            }}
          />
          <Menu>
            <MenuButton as={Button} variant="navButton">
              <AppText
                customStyles={{ as: 'span' }}
                title={username}
                size="xs"
                variant="manageLabel"
              />
              <ChevronDownIcon />
            </MenuButton>
            <MenuList>
              <MenuItem onClick={handleStudentLogout}>Logout</MenuItem>
            </MenuList>
          </Menu>
        </AppFlex>
      </Flex>
    )
  ) : (
    <Flex height="80px" justifyContent="center" alignItems="center">
      <img src={VoxGuruLogo} alt="" />
    </Flex>
  );
}

export default AppStudentNavbar;
